/* eslint-disable @typescript-eslint/no-base-to-string */
import React, { PropsWithChildren, useMemo } from 'react';
import { IocContext } from '@cp/shared/di';
import { LOGIN_FEATURE_TOKEN, useStartBillingSubscription } from 'src/features/billing';
import { PAYMENT_FEATURE } from 'src/features/dialog';
import { useClientLogin } from 'src/features/client/current/login';
import { TRY_FOR_FREE } from 'src/features/burgerMenu';
import { Container } from '../../ioc';

export const IocContainerProvider = ({ container, children }: PropsWithChildren & { container: Container }) => {
  useMemo(() => {
    console.groupCollapsed('IocContainerProvider');
    container.bind({ provide: LOGIN_FEATURE_TOKEN, useFactory: useClientLogin });
    container.bind({ provide: TRY_FOR_FREE, useFactory: () => useStartBillingSubscription()[0] });
    container.bind({ provide: PAYMENT_FEATURE, useFactory: () => useStartBillingSubscription()[0] });
    console.groupEnd();
  }, [container]);
  return <IocContext value={container}>{children}</IocContext>;
};
